import { useSelector } from 'react-redux';

export default function useMarketplaceItems() {
  const marketplaceItems = useSelector((state: any) => state.entities.marketplaceItems);

  function getMarketplaceItemById(id?: number | null) {
    if (!id || !marketplaceItems) return null;
    return marketplaceItems[id] || null;
  }

  return {
    getMarketplaceItemById,
    marketplaceItems,
  };
}
